import {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import API from "../../services/api";

function EditCustomer() {

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  const [form,
    setForm] =
    useState({
      customer_name: "",
      phone: "",
      email: "",
      gst_no: "",
      address: "",
      status: 1
    });

  useEffect(() => {
    loadCustomer();
  }, []);

  const loadCustomer =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            `/customers/${id}`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setForm(
          res.data
        );

      } catch (err) {
        console.log(err);
      }

    };

  const handleChange =
    (e) => {

      setForm({
        ...form,
        [e.target.name]:
          e.target.value
      });

    };

  const submit =
    async (e) => {

      e.preventDefault();

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.put(
          `/customers/${id}`,
          form,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        navigate(
          "/admin/customers"
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <h1
        className="
        text-3xl
        font-bold
        mb-6
        "
      >
        Edit Customer
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        space-y-5
        "
      >

        <div>
          <label className="block mb-2">
            Customer Name
          </label>

          <input
            type="text"
            name="customer_name"
            value={form.customer_name || ""}
            onChange={handleChange}
            required
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />
        </div>

        <div
          className="
          grid
          md:grid-cols-2
          gap-4
          "
        >

          <input
            type="text"
            name="phone"
            value={form.phone || ""}
            onChange={handleChange}
            placeholder="Phone"
            className="
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

          <input
            type="email"
            name="email"
            value={form.email || ""}
            onChange={handleChange}
            placeholder="Email"
            className="
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <input
          type="text"
          name="gst_no"
          value={form.gst_no || ""}
          onChange={handleChange}
          placeholder="GST Number"
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          border
          border-yellow-500/20
          "
        />

        <textarea
          rows="4"
          name="address"
          value={form.address || ""}
          onChange={handleChange}
          placeholder="Address"
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          border
          border-yellow-500/20
          "
        />

        <select
          name="status"
          value={form.status}
          onChange={handleChange}
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          border
          border-yellow-500/20
          "
        >
          <option value={1}>
            Active
          </option>

          <option value={0}>
            Inactive
          </option>
        </select>

        <button
          type="submit"
          className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          font-semibold
          "
        >
          Update Customer
        </button>

      </form>

    </div>
  );
}

export default EditCustomer;